import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-12 d-flex justify-content-center mt-3"
}
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "ticket-header-route mx-auto" }
const _hoisted_4 = { class: "ticket-departure-arrival-wrapper d-flex justify-content-between" }
const _hoisted_5 = { class: "ticket-departure-arrival-info1" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "ticket-departure-arrival-info-first mt-3" }
const _hoisted_10 = { class: "ticket-departure-arrival-info-second" }
const _hoisted_11 = { class: "info-text" }
const _hoisted_12 = { class: "ticket-departure-arrival-info-second" }
const _hoisted_13 = { class: "info-text" }
const _hoisted_14 = { class: "ticket-departure-arrival-wrapper d-flex justify-content-between" }
const _hoisted_15 = { class: "ticket-departure-arrival-info1" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = { class: "ticket-departure-arrival-info-first mt-3" }
const _hoisted_20 = { class: "ticket-departure-arrival-info-second" }
const _hoisted_21 = { class: "info-text" }
const _hoisted_22 = { class: "ticket-departure-arrival-info-second" }
const _hoisted_23 = { class: "info-text" }
const _hoisted_24 = { class: "d-inline-block w-100 ticket-additional-info" }
const _hoisted_25 = {
  class: "w-50 d-inline-flex justify-content-start",
  dir: "ltr"
}
const _hoisted_26 = { class: "w-50 d-inline-flex justify-content-end" }
const _hoisted_27 = { class: "d-inline-block w-100 ticket-additional-info" }
const _hoisted_28 = {
  class: "w-50 d-inline-flex justify-content-start",
  dir: "ltr"
}
const _hoisted_29 = { class: "w-50 d-inline-flex justify-content-end" }
const _hoisted_30 = {
  key: 0,
  class: "d-inline-block w-100 ticket-additional-info"
}
const _hoisted_31 = {
  class: "w-50 d-inline-flex justify-content-start",
  dir: "ltr"
}
const _hoisted_32 = { class: "w-50 d-inline-flex justify-content-end" }
const _hoisted_33 = { class: "d-inline-block w-100 ticket-additional-info" }
const _hoisted_34 = {
  class: "w-50 d-inline-flex justify-content-start",
  dir: "ltr"
}
const _hoisted_35 = { class: "w-50 d-inline-flex justify-content-end" }
const _hoisted_36 = { class: "d-inline-block w-100 ticket-additional-info" }
const _hoisted_37 = {
  class: "w-50 d-inline-flex justify-content-start",
  dir: "ltr"
}
const _hoisted_38 = { class: "w-50 d-inline-flex justify-content-end sum" }
const _hoisted_39 = { class: "d-flex flex-wrap mt-5" }
const _hoisted_40 = { class: "d-flex justify-content-center w-100 ticket-qr-number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.ticketData)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          id: "ticket-main-wrapper-container",
          class: _normalizeClass(["ticket-main-wrapper col-sm-12 col-md-12 col-lg-12 col-xl-9 col-xxl-7", { 'center-on-print': this.store.state.customer.printing }])
        }, [
          _createElementVNode("div", {
            class: "ticket-print-button text-gray",
            title:  _ctx.$t('print') 
          }, [
            _createElementVNode("span", {
              id: "ticket-print-button",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.print()), ["prevent"]))
            }, _cache[1] || (_cache[1] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "28",
                height: "28",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                class: "feather feather-printer"
              }, [
                _createElementVNode("polyline", { points: "6 9 6 2 18 2 18 9" }),
                _createElementVNode("path", { d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" }),
                _createElementVNode("rect", {
                  x: "6",
                  y: "14",
                  width: "12",
                  height: "8"
                })
              ], -1)
            ]))
          ], 8, _hoisted_2),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.ticketData.title), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("ul", _hoisted_5, [
              _createElementVNode("li", _hoisted_6, _toDisplayString(_ctx.$t('departure')), 1),
              _createElementVNode("li", _hoisted_7, _toDisplayString(_ctx.ticketData.pickup_addr.address_to_show), 1),
              _createElementVNode("li", _hoisted_8, _toDisplayString(_ctx.ticketData.pickup_addr.address), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[2] || (_cache[2] = _createElementVNode("svg", {
                  width: "28",
                  height: "28",
                  viewBox: "0 0 28 28",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "M13.9999 25.6663C20.4432 25.6663 25.6666 20.443 25.6666 13.9997C25.6666 7.55635 20.4432 2.33301 13.9999 2.33301C7.5566 2.33301 2.33325 7.55635 2.33325 13.9997C2.33325 20.443 7.5566 25.6663 13.9999 25.6663Z",
                    stroke: "#0029FF",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }),
                  _createElementVNode("path", {
                    d: "M14 7V14L18.6667 16.3333",
                    stroke: "#0029FF",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ], -1)),
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.ticketData.pickup.split(' ')[1]), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[3] || (_cache[3] = _createStaticVNode("<svg width=\"28\" height=\"28\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.6667 2.66675H3.33333C2.59695 2.66675 2 3.2637 2 4.00008V13.3334C2 14.0698 2.59695 14.6667 3.33333 14.6667H12.6667C13.403 14.6667 14 14.0698 14 13.3334V4.00008C14 3.2637 13.403 2.66675 12.6667 2.66675Z\" stroke=\"#0029FF\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M10.6667 1.33325V3.99992\" stroke=\"#0029FF\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M5.33334 1.33325V3.99992\" stroke=\"#0029FF\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M2 6.66675H14\" stroke=\"#0029FF\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>", 1)),
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.ticketData.pickup.split(' ')[0]), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("ul", _hoisted_15, [
              _createElementVNode("li", _hoisted_16, _toDisplayString(_ctx.$t('arrival')), 1),
              _createElementVNode("li", _hoisted_17, _toDisplayString(_ctx.ticketData.dest_addr.address_to_show), 1),
              _createElementVNode("li", _hoisted_18, _toDisplayString(_ctx.ticketData.dest_addr.address), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _cache[4] || (_cache[4] = _createElementVNode("svg", {
                  width: "28",
                  height: "28",
                  viewBox: "0 0 28 28",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "M13.9999 25.6663C20.4432 25.6663 25.6666 20.443 25.6666 13.9997C25.6666 7.55635 20.4432 2.33301 13.9999 2.33301C7.5566 2.33301 2.33325 7.55635 2.33325 13.9997C2.33325 20.443 7.5566 25.6663 13.9999 25.6663Z",
                    stroke: "#0029FF",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }),
                  _createElementVNode("path", {
                    d: "M14 7V14L18.6667 16.3333",
                    stroke: "#0029FF",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ], -1)),
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.ticketData.dropoff.split(' ')[1]), 1)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _cache[5] || (_cache[5] = _createStaticVNode("<svg width=\"28\" height=\"28\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.6667 2.66675H3.33333C2.59695 2.66675 2 3.2637 2 4.00008V13.3334C2 14.0698 2.59695 14.6667 3.33333 14.6667H12.6667C13.403 14.6667 14 14.0698 14 13.3334V4.00008C14 3.2637 13.403 2.66675 12.6667 2.66675Z\" stroke=\"#0029FF\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M10.6667 1.33325V3.99992\" stroke=\"#0029FF\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M5.33334 1.33325V3.99992\" stroke=\"#0029FF\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M2 6.66675H14\" stroke=\"#0029FF\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>", 1)),
                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.ticketData.dropoff.split(' ')[0]), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('customer')), 1),
            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.ticketData.customer), 1)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t('duration')), 1),
            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.ticketData.duration) + " " + _toDisplayString(_ctx.$t('shortened_minutes')), 1)
          ]),
          (_ctx.ticketData.total_kms)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('distance')), 1),
                _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.ticketData.total_kms.toFixed(1) + ' km'), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t('passengers')), 1),
            _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.ticketData.travellers), 1)
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('price')), 1),
            _createElementVNode("span", _hoisted_38, _toDisplayString((_ctx.ticketData.travellers * _ctx.ticketData.tax_total).toFixed(2) + ' ' + _ctx.ticketData.total_currency), 1)
          ]),
          _createElementVNode("div", _hoisted_39, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "d-flex justify-content-center w-100" }, [
              _createElementVNode("div", { id: "qr-code" })
            ], -1)),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("span", null, _toDisplayString('NR. ' + _ctx.ticketData.id), 1)
            ])
          ])
        ], 2)
      ]))
    : _createCommentVNode("", true)
}